export const totalCoursesPrice = (courseData) => {
  if (courseData) {
    const totalCourses = courseData.coursesSelected?.reduce(
      (total, course) => total + course.total,
      0
    );
    return totalCourses;
  }
};
export const totalInsurancePrice = (courseData) => {
  if (courseData) {
    const totalInsurance = courseData.insuranceSelected?.reduce(
      (total, insurance) => total + insurance.total,
      0
    );
    return totalInsurance;
  }
};
export const totalVisaPrice = (courseData) => {
  if (courseData) {
    const totalVisa = courseData.visaSelected?.reduce(
      (total, visa) => total + visa.total,
      0
    );
    return totalVisa;
  }
};

export const totalProposalPrice = (propData) => {
  if (propData) {
    const totalCourses = totalCoursesPrice(propData);
    const visaTotal = totalInsurancePrice(propData);
    const insurance = totalVisaPrice(propData);

    const totalPrice = totalCourses + visaTotal + insurance;
    return totalPrice;
  }
};

export const totalCoursesFirstPayment = (courseData) => {
  if (courseData) {
    const totalFirstPayment = courseData.coursesSelected?.reduce(
      (total, course) => total + course.firstPayment,
      0
    );
    return totalFirstPayment;
  }
};
export const minimumPayment = (propData) => {
  if (propData) {
    const totalFirstPaymentCourses = totalCoursesFirstPayment(propData);
    const visaTotal = totalVisaPrice(propData);
    const insurance = totalInsurancePrice(propData);

    const totalFirstPrice = totalFirstPaymentCourses + visaTotal + insurance;
    return totalFirstPrice;
  }
};